/**
 * Style dla react-select w kontekście np. komórek tabeli (portal)
 */

interface GetPortalStylesOptions {
  fontSize?: string;
}

export const getPortalStyles = (options?: GetPortalStylesOptions) => {
  const fontSize = options?.fontSize || '12px';
  
  return {
    control: (base: any) => ({
      ...base,
      minHeight: '38px'
    }),
    menuPortal: (base: any) => ({
      ...base,
      zIndex: 9999
    }),
    menu: (base: any) => ({
      ...base,
      marginBottom: 0,
      marginTop: 0,
      width: 'max-content',
      minWidth: '100%',
      boxShadow: 'none',
      border: '1px solid #dbdee4', // $color-table-border
      borderRadius: 0
    }),
    menuList: (base: any) => ({
      ...base,
      padding: 0
    }),
    option: (base: any, state: any) => ({
      ...base,
      padding: '4px 8px',
      margin: '4px 0',
      fontSize: fontSize,
      color: state.isSelected ? 'var(--color-secondary, var(--color-primary, #4917c7))' : '#717378', // $color-secondary : $color-label
      backgroundColor: state.isSelected
        ? '#f3f4f7' // $color-gray-background
        : state.isFocused
        ? 'transparent'
        : 'white',
      cursor: 'pointer',
      ':hover': {
        color: 'var(--color-secondary, var(--color-primary, #4917c7))', // $color-secondary (fioletowy hover tylko dla tekstu)
        backgroundColor: state.isSelected ? '#f3f4f7' : 'transparent' // $color-gray-background dla selected, transparent dla innych
      }
    })
  };
};
